import { Directive, EventEmitter, Output, HostListener, Input, OnInit, OnDestroy } from '@angular/core';
import { select } from 'd3-selection';
import { IShape } from '../interfaces/iShape';
import { Observable, BehaviorSubject } from 'rxjs';
import { tap, filter, delay, last, shareReplay, debounce, debounceTime, takeWhile } from 'rxjs/operators';


@Directive({
  selector: '[ackShapeClick]'
})
export class ShapeClickDirective implements OnInit, OnDestroy {

  @Input('ackShapeClick') enabled: boolean;

  @Output() public shapeClick: EventEmitter<IShape>;
  @Output() public shapeTripleClick: EventEmitter<IShape>;

  constructor() {
    this.shapeClick = new EventEmitter();
    this.shapeTripleClick = new EventEmitter();
    this.clicks$ = new BehaviorSubject(null);
  }

  private isDestroying = false;
  private clicks$: BehaviorSubject<{clicks: number, details: IShape} | null>;

  ngOnInit() {

    this.clicks$.pipe(
      takeWhile(() => !this.isDestroying),
      filter(val => val !== null),
      debounceTime(200),
      tap(evt => {
        switch (evt.clicks) {

          default:
            this.shapeClick.emit(evt.details);
            break;

          case 3:
            this.shapeTripleClick.emit(evt.details);
            break;

        }
      })
    ).subscribe();

  }

  ngOnDestroy() {
    this.isDestroying = true;
  }

  @HostListener('click', ['$event'])
  public click(event: any) {

    if (!this.enabled) { return; }

    const target = event.target;

    const id = target.getAttribute('id');

    if (!id) { return; }

    // select the element with d3
    const data = select(`#${id}`).datum() as IShape;

    this.clicks$.next({clicks: event.detail, details: data});
    // this.shapeClick.emit(data as IShape);

  }

  // @HostListener()

}
